import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../../../../../base/i18n.js.jsx";
import MoneyFormatter from "../../../../../utils/money_formatter.js";
import PercentFormatter from "../../../../../utils/percent_formatter.js";

import Legend from "./legend.js";

const blockStyles = makeStyles(theme => ({
  content: {
    border: `1px solid ${theme.palette.black}`,
    padding: "70px 0px",
    ['@media (max-width: 768px)']: {
      padding: "30px 24px 13px",
      borderWidth: "0.5px",
      margin: "0px -8px",
    },
  },
  inner: {
    margin: "auto",
    width: "80%",
    ['@media (max-width: 768px)']: {
      width: "100%",
    },
  },
  col: {
    padding: "0 10px",
    position: "relative",
    display: "flex",
    flex: "0 1 33.3333%",
    flexWrap: "wrap",
    flexDirection: "column",
    justifyContent: "flex-end",
    ['@media (max-width: 768px)']: {
      padding: "0 7px",
    },
    "&:first-child" : {
      paddingLeft: "0px"
    },
    "&:last-child" : {
      paddingRight: "0px"
    }
  },
  colHeaders: {
    ['@media (max-width: 768px)']: {
      margin: "0px -7px",
      textAlign: "center"
    }
  },
  colHeaderRow: {
    display: "flex",
    alignItems: "flex-start"
  },
  colArrow: {
    flexGrow: "1",
    position: "relative",
    flexBasis: "92px",
    ['@media (max-width: 768px)']: {
      flexBasis: "27px"
    },
    "&:after": {
      content: "''",
      display: "block",
      background: theme.palette.grayText,
      top: "10px",
      bottom: "0px",
      marginLeft: "-2px",
      width: "2px",
      position: "absolute",
      left: "50%",
      ['@media (max-width: 768px)']: {
        top: "-1px",
        width: "1px",
      },
    }
  },
  bar: {
    flexBasis: "90px",
    flexGrow: 0,
    ['@media (max-width: 768px)']: {
      flexBasis: "40px",
    },
  },
  colTitle: {
    fontSize: "28px",
    lineHeight: "1.3",
    margin: "0 0 6px",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      fontSize: "10px",
      padding: "0 2px",
      fontWeight: theme.typography.fontWeightMedium
    },
  },
  colSubTitle: {
    fontSize: "14px",
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: "1.4",
    marginBottom: "30px",
    wordBrake: "brake-word",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      display: "none"
    },
  },
  colRow: {
    display: "flex",
  },
  colWrapper: {
    margin: "0 -10px 28px",
    ['@media (max-width: 768px)']: {
      marginBottom: "8px"
    },
  },
  curvyRow: {
    border: `2px solid ${theme.palette.grayText}`,
    borderTop: "transparent",
    height: "25px",
    margin: "20px 0px 24px",
    ['@media (max-width: 768px)']: {
      height: "10px",
      borderWidth: "1px",
      margin: "8px 0px 12px"
    },
  },
  textRow: {
    fontSize: "24px",
    fontWeight: theme.typography.fontWeightSemibold,
    lineHeight: "1.2",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      fontWeight: theme.typography.fontWeighMedium,
    },
  },
  euroSpace: {
    ['@media (max-width: 768px)']: {
      fontSize: "2px",
    },
  }
}));

const BarDiagram = props => {
  const classes = blockStyles();
  const { className, columns, totalCost } = props;

  return (
    <div className = { clsx(classes.content, className) }>
      <div className = { classes.inner } >
        <div className = { classes.colRow }>
          { columns.map((column) => {
              const { value, key, color, name, percentValue } = column;
              return <div className = { classes.col }
                          key = { key }
                          style = {{flex: `0 1 ${percentValue}%`}}>
                <div className = { classes.colHeaders }>
                  <h6 className = { classes.colTitle }>
                    { MoneyFormatter.format(value)}
                    <span className = { classes.euroSpace }>&nbsp;</span>
                    { I18n.t("currency.euro") }
                  </h6>
                  <div className = { classes.colSubTitle }>
                    { name }
                    <div>
                      { PercentFormatter.format(percentValue / 100) }
                    </div>
                  </div>
                </div>  
                <div className = { classes.colArrow } />
                <div className = { classes.bar }
                    style = { { 
                      backgroundColor: color
                    } } />
              </div>
            }) 
          }
        </div>
        <div className = { classes.curvyRow } />
        <div className = { classes.textRow }>
          {`${I18n.t("web.page.project.financing_structure.total_cost")} ${MoneyFormatter.format(totalCost)} ${I18n.t("currency.euro")}`}
        </div>
        <Legend columns = { columns } />
      </div>
    </div>
  );
}

export default BarDiagram;